import React, { useRef, useEffect } from 'react';

/**
 * CurrentQuestion component for question display
 * Handles question visibility and animation state management
 */
const CurrentQuestion = ({
  question,
  round,
  visible,
  onHeightChange
}) => {
  const questionBoxRef = useRef(null);

  // Update height when question changes
  useEffect(() => {
    if (questionBoxRef.current && onHeightChange) {
      const height = questionBoxRef.current.offsetHeight;
      onHeightChange(height);
    }
  }, [question, visible, onHeightChange]);

  // Don't render if not visible or no question
  if (!visible || !question) {
    return null;
  }

  return (
    <div
      className={question ? "current-question-box" : "current-question-box hide"}
      ref={questionBoxRef}
    >
      <div className="current-question-label">
        Current Question (Round {round}):
      </div>
      <div className="current-question-text">
        {question}
      </div>
    </div>
  );
};

export default CurrentQuestion;